// Mock data for Prime Trade L.L.C - FZ website

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_trade-platform-prime/artifacts/h39gd4xb_IMG_1840.jpeg";

export const COMPANY = {
  name: "Prime Trade L.L.C - FZ",
  shortName: "Prime Trade",
  phonePrimary: "+971 50 827 0425",
  phoneSecondary: "+971 4 516 3636 ext. 113",
  email: "info@primetrade-fz.com",
  address:
    "Meydan Grandstand, 6th floor, Meydan Road, Nad Al Sheba, Dubai, U.A.E.",
  poBox: "P.O Box 35195",
  hours: "Mon. – Fri.: from 9:00 to 18:00",
};

export const NAV_ITEMS = [
  {
    label: "About us",
    path: "/company",
    children: [
      { label: "About us", path: "/company" },
      { label: "Prime Trade", path: "/company/prime-trade" },
      { label: "Partners", path: "/partners" },
    ],
  },
  {
    label: "Products",
    path: "/catalog",
    children: [
      { label: "Agriculture and food", path: "/catalog/agriculture-and-food" },
      { label: "Fertilizers & Chemicals", path: "/catalog/fertilizers-chemicals" },
      { label: "Oil & Gas", path: "/catalog/oil-gas" },
    ],
  },
  { label: "Partners", path: "/partners" },
  { label: "Gallery", path: "/gallery" },
  { label: "Contacts", path: "/contacts" },
];

export const HERO_SLIDES = [
  {
    type: "video",
    eyebrow: "Energizing the Global Supply Chain",
    title: "We Connect Vital Resources",
    subtitle: "To Power and Build the World",
    cta: { label: "Products", href: "/catalog" },
    video: "/videos/v0a.mp4",
    image:
      "https://images.unsplash.com/photo-1645301918921-6c744ab66e6f?auto=format&fit=crop&w=1920&q=80",
  },
  {
    type: "video",
    eyebrow: "Energising Global Trade",
    title: "A Leading Force in Physical Commodities",
    subtitle: "Advancing Sustainable Growth",
    cta: { label: "About us", href: "/company" },
    video: "/videos/v0b.mp4",
    image:
      "https://images.unsplash.com/photo-1602056820935-316884c035f8?auto=format&fit=crop&w=1920&q=80",
  },
  {
    type: "video",
    eyebrow: "Trusted Worldwide",
    title: "Reliable Partner. Real Results.",
    subtitle: "Across 30+ countries on five continents",
    cta: { label: "Our Partners", href: "/partners" },
    video: "/videos/v0c.mp4",
    image:
      "https://images.pexels.com/photos/3338019/pexels-photo-3338019.jpeg?auto=compress&cs=tinysrgb&w=1920",
  },
];

export const VALUES = [
  {
    key: "INTEGRITY",
    text: "Wherever we operate we do so with integrity.",
  },
  {
    key: "LEADERSHIP",
    text: "We are all leaders in our area of responsibility.",
  },
  {
    key: "RELIABILITY",
    text:
      "We go out of our way to meet the needs of our customers and our suppliers.",
  },
];

export const CATEGORIES = [
  {
    slug: "agriculture-and-food",
    name: "Agriculture and food",
    count: 3,
    image:
      "https://images.unsplash.com/photo-1657626625832-2c0851cdaa9b?auto=format&fit=crop&w=1200&q=80",
    description:
      "Sourcing premium grains, sugar, vegetable oils and food staples from leading producers to global markets.",
    products: [
      {
        name: "Wheat (Milling & Feed)",
        origin: "Russia, Kazakhstan, Ukraine",
        image:
          "https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?auto=format&fit=crop&w=900&q=80",
      },
      {
        name: "Raw & Refined Sugar",
        origin: "Brazil, India",
        image:
          "https://customer-assets.emergentagent.com/job_trade-platform-prime/artifacts/qimr33au_IMG_1845.jpeg",
      },
      {
        name: "Rice (Long & Short Grain)",
        origin: "India, Pakistan, Thailand",
        image:
          "https://images.unsplash.com/photo-1586201375761-83865001e31c?auto=format&fit=crop&w=900&q=80",
      },
    ],
  },
  {
    slug: "fertilizers-chemicals",
    name: "Fertilizers & Chemicals",
    count: 6,
    image:
      "https://images.unsplash.com/photo-1625246333195-78d9c38ad449?auto=format&fit=crop&w=1200&q=80",
    description:
      "Industrial-grade fertilizers and chemical raw materials supporting agriculture, manufacturing and processing industries.",
    products: [
      {
        name: "Granular Urea Mark A",
        origin: "Oman, Qatar, Russia",
        image:
          "https://customer-assets.emergentagent.com/job_trade-platform-prime/artifacts/2xyry1qd_IMG_1851.jpeg",
      },
      {
        name: "Granular Urea Mark B",
        origin: "Oman, Qatar, Russia",
        image:
          "https://customer-assets.emergentagent.com/job_trade-platform-prime/artifacts/fdbbzuqj_IMG_1846.jpeg",
      },
      {
        name: "Granular Sulphur",
        origin: "UAE, Saudi Arabia, Kazakhstan",
        image:
          "https://customer-assets.emergentagent.com/job_trade-platform-prime/artifacts/k60tzt0k_IMG_1849.jpeg",
      },
      {
        name: "Sulphur Powder",
        origin: "UAE, Saudi Arabia, Iran",
        image:
          "https://customer-assets.emergentagent.com/job_trade-platform-prime/artifacts/i0zd7f3x_IMG_1850.jpeg",
      },
      {
        name: "MOP (Muriate of Potash)",
        origin: "Russia, Belarus, Canada",
        image:
          "https://customer-assets.emergentagent.com/job_trade-platform-prime/artifacts/ya146lu4_IMG_1847.jpeg",
      },
      {
        name: "DAP (Di-Ammonium Phosphate)",
        origin: "Morocco, Saudi Arabia, Jordan",
        image:
          "https://customer-assets.emergentagent.com/job_trade-platform-prime/artifacts/ld1qz6ew_IMG_1848.jpeg",
      },
    ],
  },
  {
    slug: "oil-gas",
    name: "Oil & Gas",
    count: 2,
    image:
      "https://images.unsplash.com/photo-1588011930968-eadac80e6a5a?auto=format&fit=crop&w=1200&q=80",
    description:
      "Crude oil, refined petroleum products and LPG sourced from trusted producers and delivered globally.",
    products: [
      {
        name: "Diesel EN 590 (10 PPM)",
        origin: "UAE, GCC Refineries",
        image:
          "https://customer-assets.emergentagent.com/job_trade-platform-prime/artifacts/k7gwjamj_IMG_1855.jpeg",
      },
      {
        name: "LPG & Jet A-1",
        origin: "GCC Refineries",
        image:
          "https://images.unsplash.com/photo-1611273426858-450d8e3c9fce?auto=format&fit=crop&w=900&q=80",
      },
    ],
  },
];

export const PARTNERS = [
  { name: "Aywa", slug: "aywa", logo: "https://customer-assets.emergentagent.com/job_trade-platform-prime/artifacts/amial4gh_IMG_1856.jpeg" },
  { name: "Glencore", slug: "glencore", logo: "https://customer-assets.emergentagent.com/job_trade-platform-prime/artifacts/u78mpdai_IMG_1857.jpeg" },
  { name: "Vitol", slug: "vitol", logo: "https://customer-assets.emergentagent.com/job_trade-platform-prime/artifacts/v08fywrc_IMG_1859.jpeg" },
  { name: "Lukoil", slug: "lukoil", logo: "https://customer-assets.emergentagent.com/job_trade-platform-prime/artifacts/2dqb6xzx_IMG_1860.jpeg" },
  { name: "SOCAR", slug: "socar", logo: "https://customer-assets.emergentagent.com/job_trade-platform-prime/artifacts/wyrgxekq_IMG_1861.jpeg" },
];

export const GALLERY = [
  { type: "video", src: "/videos/v0a.mp4", thumb: "/videos/v0a.jpg", title: "Operations video 1" },
  { type: "video", src: "/videos/v0b.mp4", thumb: "/videos/v0b.jpg", title: "Operations video 2" },
  { type: "video", src: "/videos/v0c.mp4", thumb: "/videos/v0c.jpg", title: "Operations video 3" },
  { type: "video", src: "/videos/v1.mp4", thumb: "/videos/v1.jpg", title: "Operations video 4" },
  { type: "video", src: "/videos/v2.mp4", thumb: "/videos/v2.jpg", title: "Operations video 5" },
  { type: "video", src: "/videos/v3.mp4", thumb: "/videos/v3.jpg", title: "Operations video 6" },
  { type: "video", src: "/videos/v4.mp4", thumb: "/videos/v4.jpg", title: "Operations video 7" },
  { type: "video", src: "/videos/v5.mp4", thumb: "/videos/v5.jpg", title: "Operations video 8" },
];

export const STATS = [
  { number: 30, suffix: "+", label: "Countries Served" },
  { number: 15, suffix: "+", label: "Years of Expertise" },
  { number: 2500000, label: "Tons Traded Annually" },
  { number: 120, suffix: "+", label: "Global Partners" },
];
